export class TransportOption {

  id: number;
  name: string;
  children: TransportOption[] = [];
}
